(function () {
  class PlSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-plsr-input]');
      this.clearBtn = this.querySelector('[data-plsr-clear]');
      this.defaultPanel = this.querySelector('[data-plsr-default]');
      this.results = this.querySelector('[data-plsr-results]');
      this.limit = parseInt(this.dataset.plsrLimit || '6', 10);
      this.minChars = 2;
      this.timer = null;
      this.controller = null;
      this.cache = {};

      if (!this.input) return;

      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => this.onInput());

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => {
          this.input.value = '';
          this.input.focus();
          this.onInput();
        });
      }

      this.observer = new MutationObserver(() => {
        if (!this.hidden) this.refreshSliders();
      });
      this.observer.observe(this, { attributes: true, attributeFilter: ['hidden'] });
      if (!this.hidden) this.refreshSliders();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    refreshSliders() {
      requestAnimationFrame(() => {
        this.querySelectorAll('pl-slider').forEach((s) => {
          if (typeof s.update === 'function') s.update();
        });
      });
    }

    onInput() {
      const q = this.input.value.trim();
      if (this.clearBtn) this.clearBtn.hidden = q.length === 0;

      if (q.length < this.minChars) {
        this.showDefault();
        return;
      }

      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.fetch(q), 250);
    }

    showDefault() {
      clearTimeout(this.timer);
      if (this.defaultPanel) this.defaultPanel.hidden = false;
      if (this.results) {
        this.results.hidden = true;
        this.results.innerHTML = '';
      }
      this.classList.remove('is-loading');
    }

    showResults(html) {
      if (this.defaultPanel) this.defaultPanel.hidden = true;
      if (this.results) {
        this.results.innerHTML = html;
        this.results.hidden = false;
      }
      this.classList.remove('is-loading');
    }

    fetch(q) {
      if (this.cache[q]) {
        this.showResults(this.cache[q]);
        return;
      }

      this.classList.add('is-loading');
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      const url =
        '/search/suggest?q=' +
        encodeURIComponent(q) +
        '&section_id=pl-predictive-search' +
        '&resources[type]=product,query' +
        '&resources[limit]=' +
        this.limit +
        '&resources[options][unavailable_products]=last';

      fetch(url, { signal: this.controller.signal })
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const inner = doc.querySelector('[data-plsr-results-inner]');
          const html = inner ? inner.innerHTML : '';
          this.cache[q] = html;
          if (this.input.value.trim() === q) this.showResults(html);
        })
        .catch((e) => {
          if (e.name !== 'AbortError') this.classList.remove('is-loading');
        });
    }
  }

  if (!customElements.get('pl-search')) customElements.define('pl-search', PlSearch);
})();